import _classCallCheck from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { WordArray } from './core.js';
import { SHA256Algo } from './sha256.js';
/**
 * SHA-224 hash algorithm.
 */

export var SHA224Algo = /*#__PURE__*/function (_SHA256Algo) {
  _inherits(SHA224Algo, _SHA256Algo);

  var _super = _createSuper(SHA224Algo);

  function SHA224Algo() {
    _classCallCheck(this, SHA224Algo);

    return _super.apply(this, arguments);
  }

  _createClass(SHA224Algo, [{
    key: "_doReset",
    value: function _doReset() {
      this._hash = new WordArray([0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939, 0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4]);
    }
  }, {
    key: "_doFinalize",
    value: function _doFinalize() {
      var hash = _get(_getPrototypeOf(SHA224Algo.prototype), "_doFinalize", this).call(this);

      hash.sigBytes -= 4;
      return hash;
    }
  }]);

  return SHA224Algo;
}(SHA256Algo);
/**
 * Shortcut function to the hasher's object interface.
 *
 * @param {WordArray|string} message The message to hash.
 *
 * @return {WordArray} The hash.
 *
 * @static
 *
 * @example
 *
 *     var hash = CryptoJS.SHA224('message');
 *     var hash = CryptoJS.SHA224(wordArray);
 */

export var SHA224 = SHA256Algo._createHelper(SHA224Algo);
/**
 * Shortcut function to the HMAC's object interface.
 *
 * @param {WordArray|string} message The message to hash.
 * @param {WordArray|string} key The secret key.
 *
 * @return {WordArray} The HMAC.
 *
 * @static
 *
 * @example
 *
 *     var hmac = CryptoJS.HmacSHA224(message, key);
 */

export var HmacSHA224 = SHA256Algo._createHmacHelper(SHA224Algo);